import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { getMarketoFormId } from 'utils/marketo';
import { navigate } from 'gatsby';
import styled from 'styled-components';
import queryString from 'query-string';
import Cookies from 'js-cookie';
import { Form } from 'antd';
import ModalMarketingForm from 'components/Form/ModalMarketingForm';
import TextField from 'components/Core/TextField';
import Button from 'components/Core/Button';
import { init, saveForm } from 'services/marketoService';
import useMarketoFormData from 'hooks/useMarketoFormData';
import { getSetCookies } from 'utils/cookieUtility';

const InlineMarketingCta = ({
  buttonType,
  contentLeftAligned,
  data,
  dataPosition,
  enableNotification,
  formSize,
  formType,
  fullWidth,
  handleSubscribe,
  id,
  notificationMessage,
  style,
  type,
}) => {
  const [isMarketingModalOpen, toggleIsMarketingModalOpen] = useState(false);
  const marketoForm = data.marketoForm;
  const onSuccessModalMarketoForm = data.onFormSubmissionModalMarketoForm;
  const marketoFormId = parseInt(getMarketoFormId(marketoForm));
  const formData = useMarketoFormData().find(x => x.id == marketoFormId);

  const [formErrors, setFormErrors] = useState({
    email: '',
  });

  const [values, setValues] = useState({
    email: '',
  });

  const [formValid, setFormValid] = useState({
    email: 0,
  });

  const [isUpdate, setUpdate] = useState(false);

  const [active, setActive] = useState(true);

  useEffect(() => {
    init(marketoFormId);
    const tempValues = getSetCookies(values);
    setValues(tempValues);
  }, []);

  async function handleSubmit() {
    if ((await checkFieldValidate('email', values.email)) === 1) {
      if (handleSubscribe) {
        handleSubscribe(values.email);
      }

      if (enableNotification) {
        setActive(false);
      }

      if (onSuccessModalMarketoForm) {
        toggleIsMarketingModalOpen(true);
      }

      sendEmailMarketo();
      Bizible.Push('User', {
        eMail: values.email, // required
      });
      dataLayer.push({
        event: 'form submitted',
        form_type: 'Email Capture',
        'data-position': 'Hero',
        ...values,
      });
    }
  }

  const onHandleBlur = (id, newValue) => {
    checkFieldValidate(id, newValue);
  };

  const sendEmailMarketo = async () => {
    let response;

    try {
      response = await saveForm({
        ...values,
        marketoFormId,
      });
    } catch (e) {}

    Cookies.set('email', values.email);

    if (onSuccessModalMarketoForm) {
      return;
    } else if (response.data.followUpUrl) {
      window.location = response.data.followUpUrl;
    } else {
      navigate('/demo');
    }
  };

  async function checkFieldValidate(id, value) {
    let fieldValidation = formValid;
    let fieldValidationErrors = formErrors;

    fieldValidation[id] = 1;

    fieldValidation[id] = value.length >= 1 ? 1 : -1;
    fieldValidationErrors[id] = fieldValidation[id] === 1 ? '' : 'Looks like this field is blank';

    if (fieldValidation[id] === 1) {
      switch (id) {
        case 'email':
          fieldValidation[id] = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ? 1 : -1;
          break;
      }

      fieldValidationErrors[id] = fieldValidation[id] === 1 ? '' : 'Email is invalid';
    }

    setFormValid(fieldValidation);
    setFormErrors(fieldValidationErrors);
    setUpdate(!isUpdate);

    return fieldValidation[id];
  }

  const onHandleChange = (id, newValue) => {
    let tmpValues = Object.assign({}, values);
    tmpValues[id] = newValue;
    setValues(tmpValues);
  };

  const handleFocus = () => {
    if (!active) {
      setActive(true);
    }
  };

  const FormFields = (
    <>
      <Form.Item className="data-layer-form">
        <TextField
          id="email"
          type="text"
          nameType="Email"
          placeholderText={'Enter email address'}
          values={values}
          formValid={formValid}
          formErrors={formErrors}
          handleBlur={onHandleBlur}
          handleChange={onHandleChange}
          handleFocus={handleFocus}
          showOnlyFormError={type === 'header' ? true : false}
        />
      </Form.Item>
      <Form.Item>
        <Button
          type={buttonType || 'primary'}
          shadow={true}
          disabled={!active}
          style={{ display: type === 'header' && 'fit-content' }}
          button
        >
          {formData?.buttonLabel || 'Submit'}
        </Button>
      </Form.Item>
    </>
  );

  return (
    <MainContainer style={style} id={id}>
      {formSize == 'default' && (
        <SubscribeFormContainer
          onFinish={handleSubmit}
          type={type}
          $fullWidth={fullWidth}
          $contentLeftAligned={contentLeftAligned}
        >
          {FormFields}
        </SubscribeFormContainer>
      )}

      {formSize == 'small' && (
        <MinSubscribeFormContainer onFinish={handleSubmit} type={type}>
          {FormFields}
        </MinSubscribeFormContainer>
      )}

      {!active && (
        <p className="section-hero--notification" fontSize="16px" color="#00bb22">
          {notificationMessage}
        </p>
      )}
      {onSuccessModalMarketoForm && (
        <ModalMarketingForm
          dataPosition={dataPosition}
          isModalOpen={isMarketingModalOpen}
          onModalCancel={() => toggleIsMarketingModalOpen(false)}
          inlineMarketingForm={{ ...data, marketoForm: onSuccessModalMarketoForm }}
          onFormSuccess={() => toggleIsMarketingModalOpen(false)}
        />
      )}
    </MainContainer>
  );
};

InlineMarketingCta.propTypes = {
  data: PropTypes.object.isRequired,
  formSize: PropTypes.string,
};
InlineMarketingCta.defaultProps = {
  formTitle: 'Get Demo',
  handleSubscribe: null,
  enableNotification: false,
  notificationMessage: 'Thanks for subscribing!',
  formSize: 'default',
};

export const HeroInlineMarketingCta = InlineMarketingCta;
export default HeroInlineMarketingCta;

const MainContainer = styled.div`
  width: 100%;

  .section-hero--notification {
    text-align: center;
  }
`;

const SubscribeFormContainer = styled(Form)`
  display: flex;
  margin-top: 40px !important;
  width: 100%;
  justify-content: ${({ $contentLeftAligned, $fullWidth }) =>
    $fullWidth && !$contentLeftAligned ? 'center' : 'start'};

  .ant-row.ant-form-item:first-child {
    width: 100%;
    max-width: 314px;
  }
  .text-field-wrapper {
    .text-field-input {
      height: 62px !important;
      box-shadow: 0 3px 6px 1px rgba(160, 161, 188, 0.35);
    }
  }

  button {
    font-weight: bold;
    padding: 15px 24px;
    min-width: 184px;
    margin-left: 16px;
    box-shadow: 0 3px 6px 1px rgba(160, 161, 188, 0.35);

    &:hover {
      box-shadow: none;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    .ant-row.ant-form-item {
      width: 100%;
      margin-bottom: 12px;

      &:first-child {
        max-width: 100%;
      }
    }

    .text-field-wrapper .text-field-input {
      height: 55px !important;
    }

    button {
      font-size: 18px;
      line-height: 31px;
      padding: 12px 24px;
      width: 100%;
      margin-left: 0;
    }
  }
`;

const MinSubscribeFormContainer = styled(Form)`
  display: flex;
  height: 80px;
  .ant-row.ant-form-item {
    margin: ${props => props.type === 'header' && '16px 0px 0px 0px'};
  }
  .ant-row.ant-form-item:first-child {
    width: 100%;
    max-width: 314px;
  }

  .text-field-wrapper {
    .text-field-input {
      height: 44px !important;
      width: 180px;
      font-size: 14px !important;
      box-shadow: ${props =>
        props.type !== 'header' ? '0 3px 6px 1px rgba(160, 161, 188, 0.35)' : 'none'};
    }
  }

  button {
    font-weight: bold;
    font-size: 14px;
    height: 44px;
    padding: 0px 0px;
    min-width: 120px;
    margin-left: 16px;
    box-shadow: ${props =>
      props.type !== 'header' ? '0 3px 6px 1px rgba(160, 161, 188, 0.35)' : 'none'};

    &:hover {
      box-shadow: none;
    }
  }

  @media (max-width: 680px) {
    padding-left: 10px;
    padding-right: 10px;
    background-color: white;
    border-top: 1px solid #cfd8dc;
    display: flex;
    justify-content: center;

    .text-field-wrapper {
      .text-field-input {
        width: 100%;
      }
    }

    .ant-row.ant-form-item {
      margin: ${props => props.type === 'header' && '16px 0px 0px 0px'};
    }
  }
`;
